import React from 'react';
import { Trap } from '../types';
import './TrapList.css';

interface TrapListProps {
  traps: Trap[];
}

export const TrapList: React.FC<TrapListProps> = ({ traps }) => {
  const formatDuration = (startTime: string) => {
    const start = new Date(startTime);
    const now = new Date();
    const diff = now.getTime() - start.getTime();
    const minutes = Math.floor(diff / 60000);
    const hours = Math.floor(minutes / 60);

    if (hours > 0) return `${hours}h ${minutes % 60}m`;
    return `${minutes}m`;
  };

  const getTrapIcon = (type: string) => {
    switch (type) {
      case 'WEB':
        return '🌐';
      case 'SSH':
        return '🔐';
      case 'FTP':
        return '📁';
      case 'DATABASE':
        return '🗄️';
      case 'API':
        return '⚡';
      default:
        return '🎯';
    }
  };

  const activeTraps = traps.filter(t => t.status === 'RUNNING');

  return (
    <div className="trap-list">
      <div className="trap-list__header">
        <h3>Active Traps</h3>
        <span className="trap-count">{activeTraps.length}</span>
      </div>

      {activeTraps.length === 0 ? (
        <div className="no-traps">
          <p>No active traps</p>
          <span className="no-traps__subtitle">Traps will appear when attackers are detected</span>
        </div>
      ) : (
        <div className="trap-items">
          {activeTraps.map((trap) => (
            <div key={trap.id} className={`trap-card trap-card--${trap.type.toLowerCase()}`}>
              <div className="trap-card__header">
                <span className="trap-icon">{getTrapIcon(trap.type)}</span>
                <div className="trap-info">
                  <div className="trap-type">{trap.type}</div>
                  <div className="trap-label">{trap.label}</div>
                </div>
                <span className={`trap-status trap-status--${trap.status.toLowerCase()}`}>
                  {trap.status}
                </span>
              </div>

              <div className="trap-card__body">
                <div className="trap-detail">
                  <span className="trap-detail__label">Target IP:</span>
                  <span className="trap-detail__value">{trap.sourceIp}</span>
                </div>

                <div className="trap-detail">
                  <span className="trap-detail__label">Session:</span>
                  <span className="trap-detail__value">{trap.sessionId}</span>
                </div>

                <div className="trap-detail">
                  <span className="trap-detail__label">Uptime:</span>
                  <span className="trap-detail__value">{formatDuration(trap.startTime)}</span>
                </div>

                {trap.containerId && (
                  <div className="trap-detail">
                    <span className="trap-detail__label">Container:</span>
                    <span className="trap-detail__value trap-detail__value--mono">
                      {trap.containerId.substring(0, 12)}
                    </span>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
